export default __webpack_public_path__ + "static/media/logo_u.fd5ae7df.jpg";